import React from 'react';
import BaseVariables from '..';

function PatientRxVariables() {
    return (
        <BaseVariables variableGroup="Patient & RX"/>
    );
}

export default PatientRxVariables;
